<mat-toolbar *ngIf="hasToolbar" color="accent">
  <button id="goToPanelButtonShowEdit" mat-icon-button (click)="goToPanel()">
    <mat-icon class="icon-ic_arrow_back" color="secundary"></mat-icon>
  </button>
  <span>{{ 'signature.title' | translate }}</span>
</mat-toolbar>
<div class="content-iframe">
  <iframe
    title="logalty"
    #frame
    width="100%"
    height="100%"
    id="frame"
    name="frame"
    frameborder="0"
    [src]="signatureURL"
    (load)="onLoad()"
  ></iframe>

  <form target="frame" action="{{ url }}" #form method="POST" (ngSubmit)="submitForm($event)">
    <input type="hidden" name="saml_assertion" value="{{ saml }}" id="saml_assertion" />
  </form>
</div>
